import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/lib/auth';
import Landing from '@/pages/Landing';
import Home from '@/pages/Home';
import Dashboard from '@/pages/Dashboard';
import AssetDetail from '@/pages/AssetDetail';
import AddAsset from '@/pages/AddAsset';
import CashflowEngine from '@/pages/CashflowEngine';
import DebtAnalytics from '@/pages/DebtAnalytics';
import ContractManager from '@/pages/ContractManager';
import RiskOverview from '@/pages/RiskOverview';
import Opportunities from '@/pages/Opportunities';
import StrategyMonitor from '@/pages/StrategyMonitor';
import DealPipeline from '@/pages/DealPipeline';
import ExitLab from '@/pages/ExitLab';
import Reports from '@/pages/Reports';
import MacroIntelligence from '@/pages/MacroIntelligence';
import MarketDeals from '@/pages/MarketDeals';
import NewsIntelligence from '@/pages/NewsIntelligence';
import Settings from '@/pages/Settings';
import ErrorBoundary from '@/components/ErrorBoundary';
import { PortfolioProvider } from '@/lib/portfolio';
import { Toaster } from '@/components/ui/sonner';
import AppLayout from '@/components/AppLayout';
import '@/App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#F4F1EB] flex items-center justify-center"><p className="text-[14px] text-[#8C877F] animate-pulse font-sans">Loading...</p></div>;
  if (!user) return <Navigate to="/" replace />;
  return <PortfolioProvider><AppLayout><ErrorBoundary>{children}</ErrorBoundary></AppLayout></PortfolioProvider>;
}
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/home" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter><AuthProvider>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<PublicRoute><Landing /></PublicRoute>} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/portfolio" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/assets/:assetId" element={<ProtectedRoute><AssetDetail /></ProtectedRoute>} />
        <Route path="/add-asset" element={<ProtectedRoute><AddAsset /></ProtectedRoute>} />
        <Route path="/cashflow" element={<ProtectedRoute><CashflowEngine /></ProtectedRoute>} />
        <Route path="/debt" element={<ProtectedRoute><DebtAnalytics /></ProtectedRoute>} />
        <Route path="/contracts" element={<ProtectedRoute><ContractManager /></ProtectedRoute>} />
        <Route path="/risk" element={<ProtectedRoute><RiskOverview /></ProtectedRoute>} />
        <Route path="/opportunities" element={<ProtectedRoute><Opportunities /></ProtectedRoute>} />
        <Route path="/strategy" element={<ProtectedRoute><StrategyMonitor /></ProtectedRoute>} />
        <Route path="/pipeline" element={<ProtectedRoute><DealPipeline /></ProtectedRoute>} />
        <Route path="/scenarios" element={<ProtectedRoute><ExitLab /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/macro" element={<ProtectedRoute><MacroIntelligence /></ProtectedRoute>} />
        <Route path="/market" element={<ProtectedRoute><MarketDeals /></ProtectedRoute>} />
        <Route path="/news" element={<ProtectedRoute><NewsIntelligence /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/dashboard" element={<Navigate to="/home" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider></BrowserRouter>
  );
}
export default App;
